/**
 * What each aircraft reports around it: AIS ships, ADS-B traffic, the points
 * ArduPilot's avoidance is steering round, and proximity hits.
 *
 * Read-only. The server builds it from messages the aircraft already sends and
 * returns only aircraft this user can see. Mirrors
 * `api/app/domain/surroundings.py`.
 */

import { api, type ApiResult } from '@/api/client';
import type { DroneId } from '@/types/domain';

export interface ReportedShip {
  /** MMSI. */
  id: number;
  lat: number;
  lon: number;
  courseDeg: number | null;
  headingDeg: number | null;
  speedMs: number | null;
  name: string | null;
  callsign: string | null;
  lengthM: number | null;
  shipType: number | null;
  ageS: number;
}

export interface ReportedTraffic {
  /** ICAO 24-bit address. */
  id: number;
  icaoHex: string;
  lat: number;
  lon: number;
  callsign: string | null;
  altM: number | null;
  headingDeg: number | null;
  speedMs: number | null;
  ageS: number;
}

export interface AvoidancePoint {
  /** Index in the aircraft's avoidance database. */
  id: number;
  lat: number;
  lon: number;
  ageS: number;
}

export interface ProximityHit {
  bearingDeg: number;
  widthDeg: number;
  distanceM: number;
  sensor: number | null;
}

export interface SurroundingsPicture {
  droneId: DroneId;
  center: { lat: number; lon: number } | null;
  headingDeg: number | null;
  ais: ReportedShip[];
  avoid: AvoidancePoint[];
  traffic: ReportedTraffic[];
  proximity: ProximityHit[];
  ringMaxM: number | null;
}

export function listSurroundings(): Promise<ApiResult<{ surroundings: SurroundingsPicture[] }>> {
  return api.get<{ surroundings: SurroundingsPicture[] }>('/surroundings', { logged: false });
}
